import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useOwnerTransferModalProps = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const isVerifyModalOpen = !!searchParams.get('transfer_verify_open')
  const [open, setOpen] = useState(isVerifyModalOpen)

  useEffect(() => {
    if (isVerifyModalOpen) {
      setSearchParams((prev) => {
        prev.delete('transfer_verify_open')
        return prev
      })
    }
  }, [isVerifyModalOpen, setSearchParams])

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return {
    handleClose,
    handleOpen,
    open,
  }
}
